import React, { useState, useEffect } from "react";
import { motion } from "motion/react";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
};

const mobileQuery = "(max-width: 768px)";

export const Header = (props) => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(mobileQuery).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(mobileQuery);
    const handler = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return (
    <header id="header">
      <div className="intro">
        <motion.div
          className="overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <motion.h3
                  variants={fadeInUp}
                  initial="initial"
                  animate="animate"
                  transition={{
                    duration: 0.8,
                    delay: 0.3,
                    ease: [0.25, 0.1, 0.25, 1],
                  }}
                  style={{
                    fontWeight: 400,
                    fontSize: isMobile ? "16px" : "24px",
                    lineHeight: "110%",
                    letterSpacing: "0.15em",
                    textAlign: "center",
                    textTransform: "uppercase",
                  }}
                >
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </motion.h3>
                <motion.h1
                  variants={fadeInUp}
                  initial="initial"
                  animate="animate"
                  transition={{
                    duration: 0.8,
                    delay: 0.6,
                    ease: [0.25, 0.1, 0.25, 1],
                  }}
                  style={{
                    fontWeight: 700,
                    fontStyle: "normal",
                    fontSize: isMobile ? "36px" : "86px",
                    lineHeight: "115%",
                    letterSpacing: "0.1em",
                    textAlign: "center",
                  }}
                >
                  {props.data ? props.data.paragraph : "Loading"}
                </motion.h1>
                <motion.h3
                  variants={fadeInUp}
                  initial="initial"
                  animate="animate"
                  transition={{
                    duration: 0.8,
                    delay: 0.3,
                    ease: [0.25, 0.1, 0.25, 1],
                  }}
                  style={{
                    fontWeight: 400,
                    fontSize: isMobile ? "16px" : "24px",
                    lineHeight: "110%",
                    letterSpacing: "0.15em",
                    textAlign: "center",
                    textTransform: "uppercase",
                  }}
                >
                  {props.data?.date ? (
                    (() => {
                      const sep = " Ocean Marina";
                      const i = props.data.date.indexOf(sep);
                      if (i !== -1) {
                        return (
                          <>
                            {props.data.date.slice(0, i)}
                            <br />
                            {props.data.date.slice(i + 1)}
                          </>
                        );
                      }
                      return props.data.date;
                    })()
                  ) : (
                    "Loading"
                  )}
                  <span></span>
                </motion.h3>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </header>
  );
};
